import { render, staticRenderFns } from "./OdbModal.vue?vue&type=template&id=6c6152b6&"
import script from "./OdbModal.vue?vue&type=script&lang=js&"
export * from "./OdbModal.vue?vue&type=script&lang=js&"
import style0 from "./OdbModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports